import React, {useState} from "react";
import PropTypes from "prop-types";
import OtpInput from "react-otp-input";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {FormGroup, FormText, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import ZeusButton from "../../components/Button";
import {requestUserProfile, verifyPhoneNumber} from "../../redux/Actions/users.action";

const VerifyMobileModal = (props) => {
  const {email, isOpen, onCancel, phoneNumber} = props;
  const [token, setToken] = useState();
  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (token) {
      const callback = () => {
        onCancel();
        dispatch(requestUserProfile());
      };
      const payload = {email, phone_number: phoneNumber, token};
      dispatch(verifyPhoneNumber(payload, callback));
    } else {
      toast.error("Please enter OTP received on your mobile number");
    }
  };

  return (
    <Modal unmountOnClose={true} isOpen={isOpen} backdrop={"static"}>
      <ModalHeader>Verify OTP</ModalHeader>
      <ModalBody>
        <div style={{display: "flex", justifyContent: "center"}}>
          <FormGroup className="otp-container">
            <Label>Enter OTP</Label>
            <OtpInput
              containerStyle={"otp"}
              inputStyle={"otpInput"}
              inputType={"tel"}
              numInputs={6}
              onChange={setToken}
              renderInput={(props) => <input data-cy={"cy-otp"} {...props} />}
              shouldAutoFocus
              value={token}
            />
            <FormText>Please enter OTP received on your mobile number</FormText>
          </FormGroup>
        </div>
        <div style={{display: "flex", justifyContent: "end"}}>
          <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
            VERIFY
          </ZeusButton>
          <ZeusButton data-cy="cancel-btn" onClick={onCancel} className="info-small">
            CANCEL
          </ZeusButton>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VerifyMobileModal;

VerifyMobileModal.propTypes = {
  email: PropTypes.string,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  phoneNumber: PropTypes.string,
};
